<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span> <span
            class="topName">{{teamDetails['name']}}</span> </a>
</div>
<main id="main">
    <!-- <div class="video-banner">
        <div class="video-background">
            <div *ngIf="teamDetails.teamVideoUrl" class="video-foreground">
                
                <iframe [src]="transform(teamDetails.teamVideoUrl)" frameborder="0" mute="1" allow="autoplay;"
                    allowfullscreen></iframe> 
            </div>
        </div>
    </div> -->
    <!-- <div class="heading">
        <h1>{{teamDetails['name']}}
        </h1>
    </div> -->
</main><!-- End #main -->
<main id="main">

    <!-- ======= About Us Section ======= -->
    <section class="team-main-section">
        <div class="container-fluid">
            <div class="row w-100">
                <div class="col-md-6 team-logo-div">
                    <div class="main-teamdiv">
                        <div class="logo team-logo-div">
                            <img src="{{teamDetails['logoImage']}}" alt="">
                        </div>
                        <h1>{{teamDetails['name']}}
                        </h1>
                        <!-- <div class="team-social-icons">
                            <div class="social-links ">
                                <a *ngIf="teamDetails['youtubechannelurl'] !== undefined && teamDetails['youtubechannelurl']!=''"
                                    href="{{teamDetails['youtubechannelurl']}}" class="youtube"
                                    [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                        class="bx bxl-youtube"></i></a>

                                <a *ngIf="!teamDetails['youtubechannelurl'] && teamDetails['youtubechannelurl'] !== undefined"
                                    class="disabled-list youtube"><i class="bx bxl-youtube"
                                        [style]="{color: teamDetails.secondarycolor}"></i></a>

                                <a *ngIf="teamDetails['facebookurl'] !== undefined && teamDetails['facebookurl']!=''"
                                    href="{{teamDetails['facebookurl']}}" class="facebook"
                                    [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                        class="bx bxl-facebook"></i></a>

                                <a *ngIf="!teamDetails['facebookurl'] && teamDetails['facebookurl'] !== undefined"
                                    class="disabled-list facebook"><i class="bx bxl-facebook"
                                        [style]="{color: teamDetails.secondarycolor}"></i></a>
                                <a *ngIf="teamDetails['instagramurl'] !== undefined && teamDetails['instagramurl']!=''"
                                    href="{{teamDetails['instagramurl']}}" class="instagram"
                                    [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                        class="bx bxl-instagram"></i></a>

                                <a *ngIf="!teamDetails['instagramurl'] && teamDetails['instagramurl'] !== undefined"
                                    class="disabled-list instagram"><i class="bx bxl-instagram"
                                        [style]="{color: teamDetails.secondarycolor}"></i></a>
                                
                                <a *ngIf="teamDetails['linkedinurl'] !== undefined && teamDetails['linkedinurl']!=''"
                                    href="{{teamDetails['linkedinurl']}}" class="linkedin"
                                    [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                        class="bx bxl-linkedin"></i></a>

                                <a *ngIf="!teamDetails['linkedinurl'] && teamDetails['linkedinurl'] !== undefined"
                                    class="disabled-list linkedin"><i class="bx bxl-linkedin"
                                        [style]="{color: teamDetails.secondarycolor}"></i></a>
                            </div>
                        </div> -->

                    </div>
                </div>
                <div class="col-md-6 ownerSlider">
                    <div class=" swiper  ">
                        <swiper class="swiper-wrapper" fxFlex="auto" [config]="owners_config"
                            *ngIf="ownerMentorList.length > 0">
                            <div *ngFor="let ownerMentor of ownerMentorList" class=" swiper-slide">
                                <div class="ownermainDiv">
                                    <div class="left-div">
                                        <img src="{{teamDetails['logoImage']}}" alt="img2" border="0" class="watermark">
                                        <div class="ownerImage">
                                            <img src="{{ownerMentor.member_image}}" alt="" class="person" />
                                        </div>
                                    </div>
                                    <div class="user-details">
                                        <h4>
                                            {{ownerMentor.name}}
                                        </h4>
                                        <h6>{{ownerMentor.memberType}}</h6>
                                        <p>
                                            {{ownerMentor.description}}
                                        </p>
                                    </div>
                                </div>
                                <!-- <div class="team-section-list col-md-12">  
                                    <div class="container teams-icon"
                                        [style]="{background: teamDetails.secondarycolor} ">
                                        <a><img src="{{ownerMentor.member_image}}" alt="" class="person" /></a>
                                    </div>
                                    <div class="bottom-details">
                                        <h1>{{ownerMentor.name}}</h1>
                                        <p [style]="{color: teamDetails.secondarycolor} ">{{ownerMentor.memberType}}</p>
                                    </div> -->
                                <!-- <div class="team-social-icons">
                                        <div class="social-links ">
                                            <a *ngIf="ownerMentor.youtubechannelurl !== undefined  && ownerMentor.youtubechannelurl!=''"
                                                href="{{ownerMentor.youtubechannelurl}}" class="youtube"
                                                [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                                    class="bx bxl-youtube"></i></a>

                                            <a *ngIf="!ownerMentor.youtubechannelurl && ownerMentor.youtubechannelurl !== undefined"
                                                class="disabled-list youtube"><i class="bx bxl-youtube"></i></a>

                                            <a *ngIf="ownerMentor.facebookurl !== undefined && ownerMentor.facebookurl!=''"
                                                href="{{ownerMentor.facebookurl}}" class="facebook"
                                                [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                                    class="bx bxl-facebook"></i></a>

                                                    <a *ngIf="!ownerMentor.facebookurl && ownerMentor.facebookurl !== undefined"
                                                    class="disabled-list facebook"><i
                                                        class="bx bxl-facebook"></i></a>


                                            <a *ngIf="ownerMentor.instagramurl !== undefined && ownerMentor.instagramurl!=''"
                                                href="{{ownerMentor.instagramurl}}" class="instagram "
                                                [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                                    class="bx bxl-instagram"></i></a>

                                                    <a *ngIf="!ownerMentor.instagramurl && ownerMentor.instagramurl !== undefined"
                                                    class="disabled-list instagram"><i
                                                        class="bx bxl-instagram"></i></a> 
                                            <a *ngIf="ownerMentor.linkedinurl !== undefined  && ownerMentor.linkedinurl!=''"
                                                href="{{ownerMentor.linkedinurl}}" class="linkedin"
                                                [style]="{background: teamDetails.secondarycolor} " target="_blank"><i
                                                    class="bx bxl-linkedin"></i></a>

                                                    <a *ngIf="!ownerMentor.linkedinurl && ownerMentor.linkedinurl !== undefined"
                                                    class="disabled-list linkedin"><i
                                                        class="bx bxl-linkedin"></i></a> 
                                        </div>
                                    </div> -->
                                <!-- <div class="hover-div-details" [style]="{background: teamDetails.secondarycolor} ">
                                        <a class="watermark-div"><img src="{{teamDetails['logoImage']}}" alt="img2"
                                                border="0" class="hover"></a>
                                        <div class="content">
                                            <h4>{{ownerMentor.name}}</h4>
                                            <p>{{ownerMentor.description}}</p>
                                            
                                        </div>
                                    </div> -->
                                <!-- </div> -->
                            </div>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="playersDetails">
        <!-- <section id="services" class="services player-details-section" [style]="{background: teamDetails.secondarycolor} "> -->
        <div class="player container ">
            <div class="section-titleheading text-left">
                <h3 class="mainSectionTitle">Players
                </h3>
                <p class="mainpara">Get to know the best performers on the court</p>
            </div>
        </div>
        <div class="container aos-init aos-animate" data-aos="fade-up">
            <swiper class="swiper-wrapper" fxFlex="auto" [config]="players_config" *ngIf="playerList.length > 0">
                <div *ngFor="let player of playerList" class="team-players-list col-md-12">
                    <div class="player-name">
                        <h1>{{player.name}}</h1>
                    </div>
                    <div class="team-social-icons">
                        <div class="social-links ">

                            <!-- <a *ngIf="player.youtubechannelurl !== undefined && player.youtubechannelurl!=''"
                                href="{{player.youtubechannelurl}}" class="youtube"
                                [style]="{background: teamDetails.primarycolor} " target="_blank"><i
                                    class="bx bxl-youtube" [style]="{color: teamDetails.secondarycolor}"></i></a> -->

                            <!-- <a *ngIf="!player.youtubechannelurl && player.youtubechannelurl !== undefined"
                                class="disabled-list youtube" [style]="{background: teamDetails.primarycolor} "><i
                                    class="bx bxl-youtube" [style]="{color: teamDetails.secondarycolor}"></i></a> -->

                            <a *ngIf="player.facebookurl !== undefined && player.facebookurl!=''"
                                href="{{player.facebookurl}}" class="facebook" target="_blank"><i
                                    class="bx bxl-facebook"></i></a>

                            <a *ngIf="player.instagramurl !== undefined && player.instagramurl!=''"
                                href="{{player.instagramurl}}" class="instagram" target="_blank"><i
                                    class="bx bxl-instagram"></i></a>

                            <a *ngIf="player.linkedinurl !== undefined && player.linkedinurl!=''"
                                href="{{player.linkedinurl}}" class="linkedin" target="_blank"><i
                                    class="bx bxl-linkedin"></i></a>
                        </div>
                    </div>
                    <div class="playeImage">
                        <img src="{{teamDetails.logoImage}}" alt="img2" border="0" class="watemarkImage">
                        <img src="{{player.member_image}}" alt="" class="person" />
                    </div>

                </div>
            </swiper>
            <div class="swiper-pagination"></div>


            <!-- <div class="team-section-list col-md-12">
                <div class="container teams-icon">
                    <a ><img src="assets/img/teams/PUNE-1-1.png" alt="img2" border="0" class="hover"></a>
                    <a ><img src="assets/img/teams/pune/420924-RUTUJA-1_.png" alt="" class="person" /></a>
                </div>
                <div class="bottom-details">
                    <h1>Rutuja Bhosale
                    </h1>
                </div>
                <div class="team-social-icons">
                    <div class="social-links ">
                        <a href="https://www.youtube.com/channel/UCwzZgIn3_q15e9mcoSvyJbg" class="youtube"><i
                                class="bx bxl-youtube"></i></a>
                        <a href="https://www.facebook.com/tennispremierleague/" class="facebook"><i
                                class="bx bxl-facebook"></i></a>
                        <a href="https://www.instagram.com/tennispremierleague/" class="instagram"><i
                                class="bx bxl-instagram"></i></a>
                        <a href="javascript:void(0)" class="google-plus"><i class="bx bxl-skype"></i></a>
                        <a href="javascript:void(0)" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                    </div>
                </div>
            </div>
            <div class="team-section-list col-md-12">
                <div class="container teams-icon">
                    <a ><img src="assets/img/teams/PUNE-1-1.png" alt="img2" border="0" class="hover"></a>
                    <a ><img src="assets/img/teams/pune/750792-Vijay-2.png" alt="" class="person" /></a>
                </div>
                <div class="bottom-details">
                    <h1>Vijay Sundar P</h1>
                </div>
                <div class="team-social-icons">
                    <div class="social-links ">
                        <a href="https://www.youtube.com/channel/UCwzZgIn3_q15e9mcoSvyJbg" class="youtube"><i
                                class="bx bxl-youtube"></i></a>
                        <a href="https://www.facebook.com/tennispremierleague/" class="facebook"><i
                                class="bx bxl-facebook"></i></a>
                        <a href="https://www.instagram.com/tennispremierleague/" class="instagram"><i
                                class="bx bxl-instagram"></i></a>
                        <a href="javascript:void(0)" class="google-plus"><i class="bx bxl-skype"></i></a>
                        <a href="javascript:void(0)" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                    </div>
                </div>
            </div> -->
        </div>
    </section>
    <!-- ======= End About Us Section ======= -->
    <section class="gallery-section">
        <div class="container">
            <div class="row w-100">
                <div class="col-md-12">
                    <div class="content">
                        <div class="galleryMenues">
                            <ul class="nav nav-pills mb-3 topMenues" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                                        aria-selected="true">Photos</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-profile" type="button" role="tab"
                                        aria-controls="pills-profile" aria-selected="false">Videos</button>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active " id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <div class="col-md-12" id="examples">
                                    <div class="grid--content">
                                        <div class="column--wrapper" *ngIf="teamImagesArray.length > 0; else f1">
                                            <div class="post--item" *ngFor="let item of teamImagesArray">
                                                <img src="{{item.image_src}}" alt="Random Image"
                                                    (click)="openHightlightImage(item);">
                                            </div>
                                        </div>
                                        <ng-template #f1>
                                            <p>No Photos available</p>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab">
                                <div class="video-gallery">
                                    <ul class="box-container three-cols" *ngIf="teamVideoList.length > 0; else f2">
                                        <li *ngFor="let video of teamVideoList" class="box">
                                            <div class="inner">
                                                <!-- <a href="{{video.team_video}}" class="glightbox3"> -->
                                                <video class="" width="100%" controls="" loop="">
                                                    <source type="video/mp4" src="{{video.team_video}}" />
                                                </video>
                                                <!-- </a> -->
                                            </div>
                                        </li>
                                    </ul>
                                    <ng-template #f2>
                                        <p>No Videos available</p>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ======= Portfolio Section ======= -->
    <!-- ======= End About Us Section ======= -->
    <!-- <section class=" sponser-section section-performence "
        *ngIf="titleSponsorsList.length > 0 || principalSponsorsList.length > 0 || otherSponsorsList.length > 0 || ourPartnerSponsorsList.length > 0">
        <div class="container">
            <div class="row w-100">
                <div class="col-md-12">
                    <div class="section-title  main-title text-center">
                        <h2>
                            SPONSORS
                        </h2>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="content">
                        <div *ngIf="titleSponsorsList.length > 0" class="section-title sub text-center">
                            <h3>
                                TITLE SPONSORS
                            </h3>
                        </div>
                        <div *ngIf="titleSponsorsList.length > 0" class="sponser-slider">
                            <div class=" align-items-center">
                                <div *ngFor="let titleSponsors of titleSponsorsList" class="swiper-slide">
                                    <img src="{{titleSponsors.sponsors_image}}" class="img-fluid" alt="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                        <div *ngIf="principalSponsorsList.length > 0" class="section-title sub text-center">
                            <h3>
                                PRINCIPAL SPONSORS
                            </h3>
                        </div>
                        <div *ngIf="principalSponsorsList.length > 0" class="sponser-slider">
                            <div class="align-items-center">
                                <div *ngFor="let principalSponsor of principalSponsorsList" class="swiper-slide">
                                    <img src="{{principalSponsor.sponsors_image}}" class="img-fluid" alt="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                        <div *ngIf="otherSponsorsList.length > 0" class="section-title sub text-center">
                            <h3>
                                OTHER SPONSORS
                            </h3>
                        </div>
                        <div *ngIf="otherSponsorsList.length > 0" class="sponser-slider">
                            <div class=" align-items-center">
                                <div *ngFor="let otherSponsors of otherSponsorsList" class="swiper-slide">
                                    <img src="{{otherSponsors.sponsors_image}}" class="img-fluid" alt="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                        <div *ngIf="ourPartnerSponsorsList.length > 0" class="section-title sub text-center">
                            <h3>
                                OUR PARTNERS
                            </h3>
                        </div>
                        <div *ngIf="ourPartnerSponsorsList.length > 0" class="sponser-slider">
                            <div class="Images align-items-center">
                                <div *ngFor="let ourPartner of ourPartnerSponsorsList" class="swiper-slide">
                                    <img src="{{ourPartner.sponsors_image}}" class="img-fluid" alt="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->


</main><!-- End #main -->

<p-galleria [(value)]="teamImagesArray" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-item>
        <img (onslick)="openHightlightImage(item)" [src]="showHighlightImg" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>